var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 48.4C60.8008 48.7238 60.7185 49.0424 60.5611 49.3246C60.4037 49.6069 60.1766 49.8433 59.9018 50.0107L42.8742 60.5192C42.5871 60.6966 42.2583 60.7934 41.9217 60.7997C41.5852 60.806 41.253 60.7215 40.9596 60.555C40.669 60.3911 40.427 60.152 40.2583 59.8625C40.0896 59.5729 40.0005 59.2432 40 58.9073V37.8927C40.0005 37.5568 40.0896 37.2271 40.2583 36.9376C40.427 36.648 40.669 36.4089 40.9596 36.245C41.253 36.0785 41.5852 35.994 41.9217 36.0003C42.2583 36.0066 42.5871 36.1034 42.8742 36.2808L59.9018 46.7893C60.1766 46.9567 60.4037 47.1931 60.5611 47.4754C60.7185 47.7576 60.8008 48.0762 60.8 48.4Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FADA45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 47.9999C62.0008 48.3394 61.9138 48.6734 61.7473 48.9693C61.5808 49.2652 61.3406 49.5131 61.05 49.6886L43.04 60.7061C42.7364 60.8921 42.3886 60.9936 42.0326 61.0002C41.6766 61.0068 41.3253 60.9182 41.015 60.7436C40.7076 60.5718 40.4516 60.3212 40.2732 60.0176C40.0948 59.7139 40.0005 59.3683 40 59.0161V36.9836C40.0005 36.6315 40.0948 36.2858 40.2732 35.9822C40.4516 35.6786 40.7076 35.428 41.015 35.2561C41.3253 35.0816 41.6766 34.993 42.0326 34.9996C42.3886 35.0062 42.7364 35.1077 43.04 35.2936L61.05 46.3111C61.3406 46.4867 61.5808 46.7345 61.7473 47.0305C61.9138 47.3264 62.0008 47.6604 62 47.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.d06f8126.svg";
export { ForwardRef as ReactComponent };